document.addEventListener("DOMContentLoaded", function () {
    function moveProdNavBar(element) {
        var spanLeft = element.getBoundingClientRect().left;
        var clickTabWidth = element.offsetWidth / 2;
        var totalWidths = document.body.clientWidth;
        var halfWidths = totalWidths / 2;
        var spanRight = totalWidths - spanLeft;
        var scrollBox = document.querySelector(".ProdTopBar_centerTopBar");
        var scrollL = scrollBox.scrollLeft;

        if (spanRight < 200 || spanLeft < 200) {
            scrollBox.scrollLeft = scrollL + (spanLeft - halfWidths) + clickTabWidth;
        }
    }

    var prodNav = document.querySelector(".ProdTopBar_fgt");
    var tabs = document.querySelectorAll(".ProdTopBar_menulink");
    var sections = document.querySelectorAll(".link_title");
    if(!prodNav){
      return false;
    }

    var headerHeight = 0; // 适配固定头部
    var initialOffsetTop = prodNav.offsetTop; // 记录导航栏的初始位置

    // **点击 Tab 平滑滚动到目标区域**
    tabs.forEach(tab => {
        tab.addEventListener("click", function (e) {
            e.preventDefault();

            var targetId = this.getAttribute("targetOffset");
            var targetElement = document.getElementById(targetId);
            if (!targetElement) return;

            var targetOffset = targetElement.offsetTop - headerHeight ;

            window.scrollTo({
                top: targetOffset,
                behavior: "smooth"
            });

            tabs.forEach(t => t.classList.remove("ProdTopBar_menulinkActive"));
            this.classList.add("ProdTopBar_menulinkActive");
            moveProdNavBar(this);
        });
    });
    //获取二级菜单类型
    var menuType = prodNav.getAttribute("menu-type");
    var isHideDisplay = menuType === "hide-display";
    if(isHideDisplay){
        prodNav.classList.add("ProdTopBar_hide"); //默认隐藏
    }

    // **监听滚动事件**
    window.addEventListener("scroll", function () {
        var scroTop = document.documentElement.scrollTop || document.body.scrollTop;
        var prodNavOffsetTop = prodNav.getBoundingClientRect().top;

        var sectionPositions = Array.from(sections).map(el => el.offsetTop - headerHeight - 100);
        var activeIndex = 0;

        for (let i = 0; i < sectionPositions.length; i++) {
            if (scroTop >= sectionPositions[i]) {
                activeIndex = i;
            }
        }

        tabs.forEach(t => t.classList.remove("ProdTopBar_menulinkActive"));
        tabs[activeIndex].classList.add("ProdTopBar_menulinkActive");
        moveProdNavBar(tabs[activeIndex]);

        if (scroTop > initialOffsetTop) {
            prodNav.classList.add("fixed");
            document.body.classList.add("fixed-nav-padding");
            if(isHideDisplay){
                prodNav.classList.remove("ProdTopBar_hide");
            }
        } else {
            prodNav.classList.remove("fixed");
            document.body.classList.remove("fixed-nav-padding");
            if(isHideDisplay){
               prodNav.classList.add("ProdTopBar_hide");
            }
        }
    });
});
